import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// Instagram must redirect back to (and fetch media from) the domain the owner is actually on.
const PUBLIC_BASE = typeof window !== "undefined" ? window.location.origin : BACKEND_URL;
const KEY = "fff_owner_code";

export const getOwnerCode = () => localStorage.getItem(KEY) || "";
export const setOwnerCode = (c) => (c ? localStorage.setItem(KEY, c) : localStorage.removeItem(KEY));

const client = () => axios.create({
  baseURL: `${BACKEND_URL}/api/studio`,
  headers: { "X-Owner-Code": getOwnerCode() },
});

export const studioApi = {
  verify: () => client().post("/verify").then((r) => r.data),
  themes: () => client().get("/themes").then((r) => r.data),
  screens: () => client().get("/screens").then((r) => r.data),
  list: () => client().get("/posts").then((r) => r.data),
  generate: (body) => client().post("/posts/generate", body).then((r) => r.data),
  generateWeek: (body) => client().post("/calendar/generate", body).then((r) => r.data),
  update: (id, body) => client().patch(`/posts/${id}`, body).then((r) => r.data),
  regenerateImage: (id) => client().post(`/posts/${id}/regenerate-image`).then((r) => r.data),
  remove: (id) => client().delete(`/posts/${id}`).then((r) => r.data),
  igStatus: () => client().get("/instagram/status").then((r) => r.data),
  igOAuthStart: () => client().post("/instagram/oauth-start", { public_base: PUBLIC_BASE }).then((r) => r.data),
  igToken: (access_token) => client().post("/instagram/token", { access_token, public_base: PUBLIC_BASE }).then((r) => r.data),
  igDisconnect: () => client().post("/instagram/disconnect").then((r) => r.data),
  createReel: (id) => client().post(`/posts/${id}/reel`).then((r) => r.data),
  guides: () => client().get("/guides").then((r) => r.data),
  rebuildGuide: (slug) => client().post(`/guides/${slug}/rebuild`).then((r) => r.data),
  publish: (id, format) => client().post(`/posts/${id}/publish`, { format, public_base: PUBLIC_BASE }).then((r) => r.data),
};

export const fullCaption = (p) =>
  `${p.caption}\n\n${p.cta}\n.\n${(p.hashtags || []).map((t) => `#${t}`).join(" ")}${p.reel_status === "ready" && p.music_credit ? `\n\n${p.music_credit}` : ""}`.trim();

export const NIGGLES = ["Knee", "Lower back", "Shoulder", "Hip", "Neck", "Ankle", "Elbow", "Wrist"];
export const IG_REDIRECT = `${PUBLIC_BASE}/api/studio/instagram/callback`;

export const guideSlug = (region) => region.toLowerCase().replace(/ /g, "-");
export const guideUrl = (region) => `${PUBLIC_BASE}/api/studio/guides/${guideSlug(region)}.pdf`;
export const dmMessage = (region) =>
  `Here's your free ${region} guide 👇\n${guideUrl(region)}\n\nInside: the exact swaps that keep you training, a 5-minute daily reset, a 3-phase return plan and the red flags that mean see a physio.\n\nWant every session to adapt around your ${region.toLowerCase()} automatically? Start free at freefitfuel.app`;

export const errMsg = (e) => e?.response?.data?.detail || e?.message || "Something went wrong";
